import script from "./legoTabBoxExtend.vue?vue&type=script&lang=js"
export * from "./legoTabBoxExtend.vue?vue&type=script&lang=js"

import "./legoTabBoxExtend.vue?vue&type=style&index=0&id=5f8ac430&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8ac430"],['__file',"src/components/lego/extend/legoTabBoxExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f8ac430"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f8ac430', __exports__)) {
    api.reload('5f8ac430', __exports__)
  }
  
}


export default __exports__